export default __webpack_public_path__ + "static/media/getwotty_chatbot.d604afe4.png";